__turbopack_context__.v({
  "item": "ItineraryItemCard-module__whwF-a__item",
  "itemActive": "ItineraryItemCard-module__whwF-a__itemActive",
});
